import { State } from '../../interfaces/State';
import { LearnRecapState } from '../reducers/learnRecap';

export const selectLearnRecap = (state: State): LearnRecapState =>
  state.get('learnRecap');
